import { render, staticRenderFns } from "./clientesman.vue?vue&type=template&id=17a4448c&"
import script from "./clientesman.vue?vue&type=script&lang=js&"
export * from "./clientesman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports